import React, { memo } from "react";

import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

import {
    Chevron,
    ChevronContainer,
    ChevronIcon,
    ToingStampContainer,
} from "./CollapsibleBillHeaderAccessory.style";

const DEFAULT_STAMP_WIDTH = "108px";
const DEFAULT_STAMP_HEIGHT = "65px";

export interface CollapsibleBillHeaderAccessoryProps {
    isToing: boolean;
    isExpanded: boolean;
    stampId?: string;
    stampWidth?: string | number;
    stampHeight?: string | number;
    stampAlt?: string;
    currentRotation?: number;
    chevronTestId?: string;
}

const CollapsibleBillHeaderAccessory = ({
    isToing,
    isExpanded,
    stampId,
    stampWidth,
    stampHeight,
    stampAlt = "",
    currentRotation,
    chevronTestId,
}: CollapsibleBillHeaderAccessoryProps) => {
    if (isToing) {
        if (!stampId) {
            return null;
        }

        return (
            <ToingStampContainer>
                <Image
                    cloudinaryId={stampId}
                    alt={stampAlt}
                    width={stampWidth != null ? String(stampWidth) : DEFAULT_STAMP_WIDTH}
                    height={stampHeight != null ? String(stampHeight) : DEFAULT_STAMP_HEIGHT}
                />
            </ToingStampContainer>
        );
    }

    return (
        <ChevronContainer>
            <Chevron
                data-testid={chevronTestId}
                isExpanded={isExpanded}
                currentRotation={currentRotation ?? (isExpanded ? 180 : 0)}
            >
                <ChevronIcon />
            </Chevron>
        </ChevronContainer>
    );
};

export default memo(CollapsibleBillHeaderAccessory);
